import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TopgradserviceService } from '../../../../topgradservice.service';
import { FormControl } from '@angular/forms';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-student-form',
  templateUrl: './student-form.component.html',
  styleUrls: ['./student-form.component.scss']
})
export class StudentFormComponent implements OnInit {
  userDetail = null;
  taskDetail = null;
  studentFormDetail = null;
  singleStepForm = null;
  multiStepForm = null;
  elementsForm = null;
  taskId = null;
  signaturePads: SignaturePad[] = [];

  @ViewChild('canvas') canvas: ElementRef;
  signaturesArray: any = [1, 2, 3, 4, 5];

  constructor(private service: TopgradserviceService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }
    isLast:any;
  ngOnInit(): void {
    this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    this.activatedRoute.queryParams.subscribe(params => {
      if (params.taskId) {
        this.taskId = params.taskId;
        this.isLast = params.isLast;
        this.getTaskDetail(params.taskId);
      }
    });
  }

  getTaskDetail(taskId) {
    const payload = {
      placement_id: this.userDetail?.placement_id,
      student_id: this.userDetail?._id,
      task_id: taskId
    }
    this.service.getTaskDetail(payload).subscribe(async response => {
      this.taskDetail = response.result;
      if (this.taskDetail?.task_status === "completed" || (this.taskDetail?.task_status === "pending" && this.taskDetail?.status === 'declined')) {
        this.getSubmittedTask();
      }else if (this.taskDetail?.student_status === "completed") {
        this.getSubmittedTask();
      }else if (this.taskDetail?.employee_status === "completed") {
        this.getSubmittedTask();
      } else {
        this.getStudentTaskForm(this.taskDetail?.select_form);
      }
    });
  }

  async getStudentTaskForm(formId) {
    this.service.getStudentFormById({ _id: formId,student_id: this.userDetail?._id, }).subscribe(response => {
      console.log("response", response);
      this.studentFormDetail = response.data[0];
      if (this.studentFormDetail?.type === 'simple') {
        this.singleStepForm = this.studentFormDetail?.widgets?.values;
      } else if (this.studentFormDetail?.type === 'multi_step') {
        this.multiStepForm = this.studentFormDetail?.widgets?.values;
      }

      console.log("  this.studentFormDetail", this.studentFormDetail)
    });
  }

  ngAfterViewInit(): void {
    const self = this;
    setTimeout(() => {
      self.initializeSignatures();
    }, 5000);

  }

  initializeSignatures() {
    this.signaturesArray.forEach((signatureData, index) => {
      const canvas: HTMLCanvasElement = document.getElementById(`signaturePad-${index}`) as HTMLCanvasElement;
      if (canvas) {
        const signaturePad = new SignaturePad(canvas);
        this.signaturePads.push(signaturePad);
      }
    });
  }

  cancelSignature(i, item) {
    this.signaturePads[i].clear();
    item.signature = {};
    setTimeout(() => {
      const canvas: HTMLCanvasElement = document.getElementById(`signaturePad-${i}`) as HTMLCanvasElement;
      if (canvas) {
        this.signaturePads[i] = new SignaturePad(canvas);
      }
    }, 1000);
  }

  uploadFile(event, field) {
    if (event.target.files[0].size > field?.elementData?.size * 1048576) {
      this.service.showMessage({
        message: 'Please select file less than ' + field?.elementData?.size + ' MB'
      });
      return;
    }
    event.target.files.forEach(file => {
      const formData = new FormData();
      formData.append('media', file);
      this.service.uploadOthersMedia(formData).subscribe((resp: any) => {
        field.elementData.value = field.elementData.value?.length > 0 ? field.elementData.value : [];
        field.elementData.value.push(resp);
      });
    });
    event.target.value = "";
  }

  getValueInsideSingleBracket(input) {
    if (!input) {
      return;
    }
    input = input.join(' ');
    const regex = /\((.*?)\)/g;
    const matches = input.match(regex);

    if (matches) {
      return matches.join(', ').replace(/[()]/g, '');
    } else {
      return [];
    }
  }

  getFile(i, item) {
    // this.signaturePads.forEach((signaturePad, i) => {
    const dataURL = this.signaturePads[i].toDataURL('image/svg+xml');
    const file = this.dataURLToBlob(dataURL);
    const formData = new FormData();
    formData.append('media', file);
    this.service.uploadMedia(formData).subscribe((resp: any) => {
      item.signature = resp;
      // if (this.studentFormDetail?.type === 'simple') {
      //   this.singleStepForm.forEach(form => {
      //     if (form.id === 'signature') {
      //       form.elementData.value = !form.elementData.value ? [] : form.elementData.value;
      //       form.elementData.value.push(resp);
      //     }
      //   })
      // } else if (this.studentFormDetail?.type === 'multi_step') {
      //   this.multiStepForm.forEach(form => {
      //     form.component.forEach(comp => {
      //       if (comp.id === 'signature') {
      //         comp.elementData.value = !comp.elementData.value ? [] : comp.elementData.value;
      //         comp.elementData.value.push(resp);
      //       }
      //     })
      //   })
      // }
      // if (i === this.signaturePads.length - 1) {
      //   // callback();
      // }
    });
    // }); 
  }

  dataURLToBlob(dataURL) {
    const parts = dataURL.split(';base64,');
    const contentType = parts[0].split(':')[1];
    const raw = window.atob(parts[1]);
    const rawLength = raw.length;
    const uInt8Array = new Uint8Array(rawLength);
    for (let i = 0; i < rawLength; ++i) {
      uInt8Array[i] = raw.charCodeAt(i);
    }
    return new Blob([uInt8Array], { type: contentType });
  }

  submitForm() {
    if (this.studentFormDetail?.type === 'simple') {
      // if (this.signaturePads.length > 0) {
      //   this.getFile(() => {
      //     this.submitWorkflowttachment(this.singleStepForm);
      //   });
      // } else {
      this.submitWorkflowttachment(this.singleStepForm);
      // }
    } else if (this.studentFormDetail?.type === 'multi_step') {
      // if (this.signaturePads.length > 0) {
      //   this.getFile(() => {
      //     this.submitWorkflowttachment(this.multiStepForm);
      //   });
      // } else {
      this.submitWorkflowttachment(this.multiStepForm);
      // }
    }
  }

  submitWorkflowttachment(fields) {
    const payload = {
      placement_id: this.userDetail?.placement_id,
      student_id: this.userDetail?._id,
      task_id: this.taskId,
      task_status: "completed",
      employee_status:  this.taskDetail?.employee_status=="completed"? this.taskDetail?.employee_status: "pending",
      type: 'student',
      form_fields: { fields, type: this.studentFormDetail?.type },
      vacancy_id: this.userDetail?.company_allocation[0]?.vacancy_id,
      company_id: this.userDetail?.company_allocation[0]?.company_id,
      form_id: this.studentFormDetail?._id?this.studentFormDetail?._id:this.taskDetail?.select_form,
      is_last:this.isLast==1?1:0,
      student_name: this.userDetail?.first_name + ' ' + this.userDetail?.last_name,
      student_status:"completed",
    }
    // if(this.isLast==1){
    //   this.submitLastPendingForm({
    //     placement_id: this.userDetail?.placement_id,
    //     student_id: this.userDetail?._id,
    //     task_id: this.taskId,
    //     task_status: "completed",
    //     employee_status: "pending",
    //     type: 'student',
    //     form_fields: { fields, type: this.studentFormDetail?.type },
    //     vacancy_id: this.userDetail?.company_allocation[0]?.vacancy_id,
    //     company_id: this.userDetail?.company_allocation[0]?.company_id,
    //     form_id: this.studentFormDetail?.form_id? this.studentFormDetail?.form_id:this.taskDetail?.select_form,
    //     is_last:this.isLast==1?1:0,
    //     student_name: this.userDetail?.first_name + ' ' + this.userDetail?.last_name
    //   });
    // }
    this.service.submitWorkFlowForm(payload).subscribe(res => {
      // if(this.isLast==1){
       
      // }else{
        this.service.showMessage({
          message: "Task submitted successfully"
        });
        this.router.navigate(['/student/my-placements']);
      // }
      
    }, err => {
      this.service.showMessage({
        message: err.error.errors ? err.error.errors.msg : 'Something went Wrong'
      });
    })
  }

  submitLastPendingForm(body) {
    const payload =body
    this.service.submitLastPendingForm(payload).subscribe(res => {
      this.service.showMessage({
        message: "Task submitted successfully"
      });
      this.router.navigate(['/student/my-placements']);
    }, err => {
      this.service.showMessage({
        message: err.error.errors ? err.error.errors.msg : 'Something went Wrong'
      });
    })
  }


  getSubmittedTask() {
    const payload = {
      placement_id: this.userDetail?.placement_id,
      student_id: this.userDetail?._id,
      task_id: this.taskId,
      company_id: this.userDetail?.company_allocation[0]?.company_id,
    }
    this.service.getSubmittedWorkFlowTask(payload).subscribe((response: any) => {
      if (response.result) {
        this.studentFormDetail = { 
          type: response.result?.form_fields?.type,
          student_name: response.result?.student_name,
          employer_name: response.result?.employer_name,
          staff_name: response.result?.staff_name,
          student_submitted_at: response.result?.student_submitted_at,
          employer_submitted_at:response.result?.employer_submitted_at,
          staff_submitted_at: response.result?.staff_submitted_at
        }
        if (this.studentFormDetail?.type === 'simple') {
          this.singleStepForm = response.result?.form_fields?.fields;
        } else if (this.studentFormDetail?.type === 'multi_step') {
          this.multiStepForm = response.result?.form_fields?.fields;
        }
      }
    });
  }

  // checkIsFormValid(formFields) {
  //   if (formFields && formFields.length > 0) {
  //     return formFields.some(form => (form.id !== 'signature' && form.id !== 'checkbox' && form.elementData?.required && !form.elementData?.value) ||
  //       (form.id === 'signature' && form.elementData.items.some(item => (item.item === 'Student') && (!item?.signature || Object.keys(item.signature).length === 0))) ||
  //       (form.id === 'checkbox' && !form.elementData.items.some(item => item.selected)));
  //   } else {
  //     return true;
  //   }
  // }



  checkIsFormValid(formFields) {


    if (formFields && formFields.length > 0) {

      

      return formFields.some(form => {
        // First, check if permission exists and has the necessary properties
      return  (form.elementData?.permissions?.student?.read == true && form.elementData?.permissions?.student?.write == true && form.elementData?.required) &&
        
        // Then, apply the rest of the logic
        (
            (form.id !== 'signature' && form.id !== 'checkbox' && form.elementData?.required && !form.elementData?.value) ||
            (form.id === 'signature' && form.elementData.items.some(item => item.item === 'Employer' && (!item?.signature || Object.keys(item.signature).length === 0))) ||
            (form.id === 'checkbox' && !form.elementData.items.some(item => item.selected))
        )}
      );

      // return formFields.some(form => (form.id !== 'signature' && form.id !== 'checkbox' && form.elementData?.required && !form.elementData?.value) ||
      //   (form.id === 'signature' && form.elementData.items.some(item => (item.item === 'Employer') && (!item?.signature || Object.keys(item.signature).length === 0))) ||
      //   (form.id === 'checkbox' && !form.elementData.items.some(item => item.selected)));
    
    } else {
      return true;
    }
  }
  downloadFile(url: string) {
    window.open(url);
  }

  async downloadPDF(url: string, filename: string): Promise<void> {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
      window.URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error('There was an error downloading the PDF:', error);
      this.downloadFile(url);
    }
  }

  async viewPDF(url: string): Promise<void> {
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      window.open(blobURL, '_blank');
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error('There was an error viewing the PDF:', error);
      this.downloadFile(url);
    }
  }

  today: any = null;

  checkDatachange(data) {
    // console.log("dtaat", data);
  }
  checkDataValidation(data) {
    if (data.title === "Internship End Date") {
      return true;
    } else {
      if (data.value) {
        this.today = new Date(new Date(data.value).setDate(new Date(data.value).getDate() - 1));
      }
      return false;
    }
  }

  checkFieldPermission(permissions) {
    // if (this.taskDetail?.task_status !== 'completed') {
      if (permissions?.student.write && permissions?.student.read) {
        return 'editable';
      } else if (!permissions?.student.write && permissions?.student.read) {
        return 'readOnly';
      } else {
        return 'hidden';
      }
    // }
  }

  checkDropDownFieldPermission(permissions) {
    if (this.studentFormDetail?.staff_status !== 'completed') {
      if (permissions?.student.write && permissions?.student.read) {
        return false;
      } else if (!permissions?.student.write && permissions?.student.read) {
        return true;
      } else {
        return true;
      }
    }
  }
}
